import * as importerActions from '../../actions/admin/adminImporterActions'
import * as h2Api from '../../h2Api'

const initialResponses = {
  dataType: null,
  filters: {},
  mappings: {}
}
const testTypes = [
  {
    id: 'user',
    name: 'Users',
    filters: [
      { id: 'FROW', name: 'Ignore first row' },
      { id: 'EMAILCONFIRM', name: 'Email users a confirmation' },
      { id: 'AUTOCONFLICT', name: 'Autoresolve Username Conflicts' },
      { id: 'AUTOPW', name: 'Autogenerate Password' }
    ],
    fields: [
      {
        id: 'EMAIL',
        name: 'E-Mail Address',
        required: true,
        aliases: ['e-mail', 'email', 'e-mail', 'email address', 'e-mail address']
      },
      { id: 'FIRSTNAME', name: 'First Name', aliases: ['first', 'fname'] },
      { id: 'LASTNAME', name: 'Last Name', aliases: ['last', 'lname', 'surname'] },
      { id: 'PW', name: 'Password' },
      { id: 'SCHOOL', name: 'School', aliases: ['schoolname', 'school name'] },
      {
        id: 'USER',
        name: 'User Name',
        required: true,
        aliases: ['user', 'username', 'uname', 'uid']
      },
      { id: 'ZIPCODE', name: 'Zip Code', required: true, aliases: ['zip', 'zipcode'] },
      {
        id: 'GRADUATION',
        name: 'Graduation Year',
        required: false,
        aliases: ['graduation', 'graduation year']
      }
    ]
  },
  {
    id: 'assignment',
    name: 'Group Assignments',
    filters: [{ id: 'FROW', name: 'Ignore first row' }],
    fields: [
      {
        id: 'EMAIL',
        name: 'E-Mail Address',
        required: true,
        aliases: ['e-mail', 'email', 'e-mail', 'email address', 'e-mail address']
      },
      { id: 'FIRSTNAME', name: 'First Name', aliases: ['first', 'fname'] },
      { id: 'LASTNAME', name: 'Last Name', aliases: ['last', 'lname', 'surname'] },
      { id: 'PW', name: 'Password' },
      { id: 'SCHOOL', name: 'School', aliases: ['schoolname', 'school name'] },
      {
        id: 'USER',
        name: 'User Name',
        required: true,
        aliases: ['user', 'username', 'uname', 'uid']
      },
      { id: 'ZIPCODE', name: 'Zip Code', required: true, aliases: ['zip', 'zipcode'] },
      {
        id: 'GRADUATION',
        name: 'Graduation Year',
        required: false,
        aliases: ['graduation', 'graduation year']
      }
    ]
  }
]
const initialUploadProgress = {
  errors: null,
  active: false,
  pctComplete: 5,
  selected: ''
}
const initialState = {
  isOpen: false,
  currentStepIndex: 1,
  responses: initialResponses,
  uploadProgress: initialUploadProgress,
  loadedData: [],
  importRequest: h2Api.initialRestState(),
  types: []
}
const reducers = (state = initialState, action) => {
  switch (action.type) {
    case importerActions.SET_POSITION:
      return {
        ...state,
        currentStepIndex: action.step
      }

    case importerActions.SET_DATA_TYPE:
      return {
        ...state,
        responses: {
          ...state.responses,
          dataType: action.dataType
        }
      }

    case importerActions.IMPORTER_OPEN:
      return {
        ...state,
        isOpen: true
      }

    case importerActions.IMPORTER_CLOSE:
      return initialState

    case importerActions.COL_TYPE_SELECTED:
      let mping = {}

      if (action.dataType) {
        mping = {
          ...state.responses.mappings,
          [action.column]: action.dataType
        }
      } else {
        mping = {
          ...state.responses.mappings
        }
        delete mping[action.column]
      }

      return {
        ...state,
        responses: {
          ...state.responses,
          mappings: mping
        }
      }

    case importerActions.IMPORTER_LOAD_TYPES:
      if (action.restCall.status === h2Api.REST_CALL_STATUS.RECEIVED) {
        return {
          ...state,
          types: action.restCall.result
        }
      }

      return state

    case importerActions.FILTER_VAL_SELECTED:
      return {
        ...state,
        responses: {
          ...state.responses,
          filters: {
            ...state.responses.filters,
            [action.id]: action.isSet
          }
        }
      }

    case importerActions.DATA_IMPORTED:
      const nextState = {
        ...state,
        importRequest: h2Api.restReducer(importerActions.DATA_IMPORTED)(state, action)
      }

      if (action.restCall.status === h2Api.REST_CALL_STATUS.RECEIVED) {
        return {
          ...nextState,
          importResult: action.restCall.result,
          uploadProgress: initialUploadProgress
        }
      }

      return nextState

    case importerActions.FILE_PARSED:
      if (action.restCall.status === h2Api.REST_CALL_STATUS.RECEIVED) {
        return {
          ...state,
          loadedData: action.restCall.result
        }
      }

      if (action.restCall.status === h2Api.REST_CALL_STATUS.ERROR) {
        return {
          ...state,
          uploadProgress: {
            ...initialUploadProgress,
            errors: action.restCall.result
          }
        }
      }

      if (action.restCall.status === h2Api.REST_CALL_STATUS.UPLOADING) {
        return {
          ...state,
          uploadProgress: {
            ...state.uploadProgress,
            errors: null,
            active: true,
            pctComplete: action.restCall.complete
          }
        }
      }
  }

  return state
}

export default reducers
